import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

// constants
export const FETCH_SITE_LIST = 'layout/FETCH_SITE_LIST'
export const SET_SITE_LIST = 'layout/SET_SITE_LIST'
export const RESET_LAYOUT_STORE = 'layout/RESET_LAYOUT_STORE'
export const SET_HEADER_FILTER_COMPONENT = 'layout/SET_HEADER_FILTER_COMPONENT'
export const CLEAR_HEADER_FILTER_COMPONENT =
  'layout/CLEAR_HEADER_FILTER_COMPONENT'
export const TOGGLE_MOBILE_MENU = 'layout/OPEN_MOBILE_MENU'
export const CLOSE_MOBILE_MENU = 'layout/CLOSE_MOBILE_MENU'
export const SET_SIDENAV_SUBMENU = 'layout/SET_SIDENAV_SUBMENU'
export const SET_WINDOW_SIZES = 'layout/SET_WINDOW_SIZES'
export const SET_ACCESS_DENIED = 'layout/SET_ACCESS_DENIED'

// actions
export const fetchSiteList = ActionHelper.createActionObj(SET_WINDOW_SIZES)
export const fetchLocusList = ActionHelper.createActionObj(FETCH_SITE_LIST)
export const resetLayoutStore = ActionHelper.createActionObj(RESET_LAYOUT_STORE)
export const setHeaderFilterComponent = ActionHelper.createActionObj(
  SET_HEADER_FILTER_COMPONENT,
)
export const clearHeaderFilterComponent = ActionHelper.createActionObj(
  CLEAR_HEADER_FILTER_COMPONENT,
)
export const toggleMobileMenu = ActionHelper.createActionObj(TOGGLE_MOBILE_MENU)
export const closeMobileMenu = ActionHelper.createActionObj(CLOSE_MOBILE_MENU)
export const setSideNavSubmenu = ActionHelper.createActionObj(
  SET_SIDENAV_SUBMENU,
)
export const setWindowSizes = ActionHelper.createActionObj(SET_WINDOW_SIZES)
export const setAccessDenied = ActionHelper.createActionObj(SET_ACCESS_DENIED)

// store
function initialStore() {
  return fromJS({
    windowSizes: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
    siteList: [],
    locusList: [],
    component: null,
    isOpen: false,
    isAccessDenied: false,
    sideNavSubMenu: {
      isOpen: false,
      title: '',
      menu: [],
    },
  })
}

// reducer
const layout = handleActions(
  {
    [TOGGLE_MOBILE_MENU]: state => state.set('isOpen', !state.get('isOpen')),
    [CLOSE_MOBILE_MENU]: state => state.set('isOpen', false),
    [SET_SITE_LIST]: (state, action) =>
      state.set('siteList', List(action.siteList)),
    [SET_HEADER_FILTER_COMPONENT]: (state, action) =>
      state.set('component', action.payload),
    [CLEAR_HEADER_FILTER_COMPONENT]: state => state.set('component', null),
    [SET_SIDENAV_SUBMENU]: (state, action) =>
      state.set('sideNavSubMenu', Map(action.payload)),
    [SET_WINDOW_SIZES]: (state, action) =>
      state.set('windowSizes', Map(action.payload)),
    [SET_ACCESS_DENIED]: (state, action) =>
      state.set('isAccessDenied', action.payload),
    [RESET_LAYOUT_STORE]: () => initialStore(),
  },
  initialStore(),
)

export default layout
